import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './AlertTitlesStyles';

export default class AlertTitles extends Component {
  render() {
    return (
        <div className={css(styles.titlesWrapper)}>
          <span className={css(styles.leftSide)}>All alerts</span>
          <span className={css(styles.rightSide)}>Showing most recent first</span>
        </div>
    );
  }
}
